import { render, staticRenderFns } from "./six.vue?vue&type=template&id=4f168152&scoped=true&"
import script from "./six.vue?vue&type=script&lang=js&"
export * from "./six.vue?vue&type=script&lang=js&"
import style0 from "./six.vue?vue&type=style&index=0&id=4f168152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f168152",
  null
  
)

export default component.exports